/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/cellSets/initialState';
var cellSetsLoading = produce(function (draft) {
  draft.initialLoadPending = false;
  draft.loading = true;
  draft.cellIdsLoaded = false;
  draft.error = false;
}, initialState);
export default cellSetsLoading;